import * as t from "io-ts";

export const FileRefValidator = t.intersection([
  t.type({
    name: t.string,
    url: t.string,
  }),
  t.partial({
    // optional props here
  }),
]);

export const FileRefArrayValidator = t.array(FileRefValidator);

export type FileRef = t.TypeOf<typeof FileRefValidator>;
export type FileRefArray = t.TypeOf<typeof FileRefArrayValidator>;
